export default __webpack_public_path__ + "static/media/preference content2.01a3da1b.jpg";